import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Box,
  alpha,
  InputBase,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Button,
  InputAdornment,
  TextField,
  Tooltip,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentScheme } from "../../store/action";
import history from "../../utils/HistoryUtils";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import apiConfigs from "../../config/config";
import axios from "axios";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import Loading from "../../components/Loading/Loading";
import { Visibility } from "@material-ui/icons";
import TablePaginationControls from "../../components/TablePaginationControls";
import { Link as RouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import { ThemeContext } from "../../App";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },


  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(),
      width: "auto",
    },
  },
  actions: {
    display: "flex",
    // justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
}));

const ViewPaymentScheme = ({ match }) => {
  const theme = useTheme();
  const { mode } = useContext(ThemeContext)
  const classes = useStyle();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchData, setSearchData] = useState({ search: "" });
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const loginUserInfo = JSON.parse(
    window.localStorage.getItem("loginUserInfo")
  );
  const { getPaymentSchemeItem, loading } = useSelector(
    (state) => state.paymentScheme
  );

  const getList = (
    pageNo = 1,
    perPage = perPage,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getPaymentScheme({ pageNo, perPage, search, type, column_name }));
  };

  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getList(value, perPage), 2000);
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(page);
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1.length > 2) {
      setTimeout(getList(page, perPage, d1), 1000);
    } else {
      setTimeout(getList(page, perPage, ""), 1000);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getList(page, perPage, searchData.search), 1000);
  };

  const dublicatePaymentScheme = async (booking_id) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/dublicate-paymentscheme/${booking_id}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status == true) {
          setTimeout(() => {
            getList();
          }, 100);
        }
      })
      .catch((error) => {
        console.error("error.message", error.message);
      });
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (
      (loginUserInfo?.role == "STAFF") ||
      loginUserInfo?.role == "ORGANIZATION" ||
      loginUserInfo?.is_consulatant == "Yes"
    ) {
      getList(page, perPage, searchData.search);
    }
  }, [orderBy, order, perPage]);

  const startIndex = (page - 1) * perPage;
  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);
  return (
    <>
      {loading && <Loading open={loading} />}

      {((loginUserInfo?.role == "STAFF") ||
        loginUserInfo?.role == "ORGANIZATION" ||
        loginUserInfo?.is_consulatant == "Yes") && (
          <Paper className={`${classes.root}`}>
            <Box className="mb-5" display="flex" justifyContent="space-between" alignItems="center">

              <TextField
                size="small"
                placeholder="Search now..."
                name="search"
                variant="outlined"
                onChange={handleSearchChange}
                onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon onClick={handleClickSearch} />
                    </InputAdornment>
                  ),
                }}
                className="modernSearchField"
              />

              {(loginUserInfo?.role === "ORGANIZATION" ||
                ((loginUserInfo?.role === "STAFF" &&
                  loginUserInfo?.permissions?.some(p => p.toLowerCase() === "payment-scheme-create")) || (loginUserInfo?.role !== "STAFF")) ||
                staffDetail === "Admin" ||
                (getPaymentSchemeItem?.data?.isConsultant === "No" &&
                  staffDetail !== "Booking" &&
                  staffDetail !== "Finance")) && (
                  <div className="ml-5">
                    <Button variant="contained" color="primary" component={Link} to={`${match.url}/create`} startIcon={<AddIcon className="mr-2" />}>
                      Add Rate
                    </Button>
                  </div>
                )}
            </Box>

            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={(event, property) => {
                    handleRequestSort(
                      property,
                      setOrder,
                      setOrderBy,
                      orderBy,
                      order
                    );
                  }}
                  rowCount={getPaymentSchemeItem?.data?.data?.length}
                  headCells={headCells[0]}
                />

                <TableBody>
                  {getPaymentSchemeItem?.data?.data &&
                    getPaymentSchemeItem?.data?.data.map((list, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell scope="row" style={{ color: theme.palette.listItem }}>{index + 1}</TableCell>
                          <TableCell align="left">
                            <MuiLink
                              component={
                                (loginUserInfo?.role === "STAFF" &&
                                  loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "payment-scheme-view")) ||
                                  loginUserInfo?.role !== "STAFF" ? RouterLink : "span"
                              }
                              to="#"
                              onClick={(e) => {
                                if ((loginUserInfo?.role === "STAFF" &&
                                  loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "payment-scheme-view")) ||
                                  loginUserInfo?.role !== "STAFF") {
                                  e.preventDefault();
                                  onhandlClick(list.id)
                                } else {
                                  e.preventDefault();
                                }
                              }}
                              underline="hover"
                              sx={{
                                cursor: (loginUserInfo?.role === "STAFF" &&
                                  loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "payment-scheme-view")) || (loginUserInfo?.role !== "STAFF") ? "pointer" : "not-allowed",
                                color: "#3e81c3"

                              }}
                              className="clickableLink"
                            >
                              {list.name}
                            </MuiLink>
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.speciality_name}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.grade_name}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.day_from}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.day_to}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{list.remark}</TableCell>
                          <TableCell align="center" style={{ color: theme.palette.listItem }}>
                            <Box className={classes.actions}>
                              {(loginUserInfo?.role === "ORGANIZATION" ||
                                staffDetail === "Admin" ||
                                (getPaymentSchemeItem?.data?.isConsultant === "No" &&
                                  staffDetail !== "Booking" &&
                                  staffDetail !== "Finance")) && (
                                  <Box
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => dublicatePaymentScheme(list.id)}
                                  >
                                    <Tooltip title="Copy Payment Scheme"><FileCopyOutlinedIcon /></Tooltip>
                                  </Box>
                                )}
                              {/* 
                              {((loginUserInfo?.role === "STAFF" &&
                                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "payment-scheme-view")) ||
                                (loginUserInfo?.role !== "STAFF")) && (
                                  <Box
                                    variant="outlined"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => onhandlClick(list.id)}
                                  >
                                    <Visibility variant="outlined" size="small" />
                                  </Box>
                                )} */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}

                  {getPaymentSchemeItem?.data?.data?.length == 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan="8" scope="">
                        {" "}
                        Sorry no record available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePaginationControls
              page={page}
              rowsPerPage={perPage}
              totalRecords={getPaymentSchemeItem?.data?.total}
              onPageChange={handleChangePage}
              handlePerPageChange={handlePerPageChange}
            />
          </Paper>
        )}
    </>
  );
};
export default ViewPaymentScheme;
